module.exports = __webpack_public_path__ + "static/media/congratulations_illustration_myway.331ef519.svg";